import { useCheckViewPoint, VIEW_POINT_CONFIG } from "hooks/useCheckViewPoint";
import { Col, Row } from "v2/components/base/Flex/ui";

const MainPageLayout = ({
  Title,
  children,
}: {
  Title: React.ReactNode;
  children: React.ReactNode;
}) => {
  const isMobile = useCheckViewPoint(VIEW_POINT_CONFIG.MOBILE);

  return (
    <Col type="ss" sx={{ gap: isMobile ? "24px" : "42px" }} fullWidth fullHeight>
      <TitleSection Title={Title} />
      {children}
    </Col>
  );
};

const TitleSection = ({ Title }: { Title: React.ReactNode }) => {
  return (
    <Row type="sc" sx={{ marginTop: "4px" }} fullWidth>
      {Title}
    </Row>
  );
};

export { MainPageLayout };
